import React from "react";
import { connect } from "react-redux";
import { Aggregators } from "../../components/Aggregator";
import { DashboardHeader } from "../../components/Header";

class AggregatorScreen extends React.Component {
  render() {
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader
            title={"Aggregators"}
            titleClassName="text-primary"
          />
          <Aggregators showAdd />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(AggregatorScreen);
